import "./login.scss"
import "antd/dist/antd.less";
import React from "react";
import ReactDOM from "react-dom";
import Particles from 'react-particles-js';
import Login from "../../components/login";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Register from './../../components/register/index';
import Forget from './../../components/forget/index';
import logo from "../../assets/img/logo.png";
import Reset from "../../components/reset";
const app =
    <Router>
        <div className="body">
            <div className="form_container">
                <div className="login-logo"><img src={logo} alt={"logo"} /></div>
                <Route path="/login*" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/forget" component={Forget} />
                <Route path="/reset" component={Reset} />
            </div>
            <div style={{ width: "100%" }}>
                {/* <Particles
                    params={{
                        "particles": {
                            "number": {
                                "value": 50
                            },
                            "size": {
                                "value": 3
                            }
                        },
                        "interactivity": {
                            "events": {
                                "onhover": {
                                    "enable": true,
                                    "mode": "repulse"
                                }
                            }
                        }
                    }} /> */}
            </div>
        </div>
    </Router >

ReactDOM.render(app, document.getElementById("root"));